export default function arrayToString (array, separator = ', ') {
  if (Array.isArray(array)) {
    return array?.join(separator)
  } else {
    return array
  }
}
